import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';
import NumberInput from './NumberInput';

var config = process.env;

class RestockingProductComponent extends Component {

    constructor(){
        super();
        this.state = {
            items: [],
            itemsFiltered: [],
            itemsSelected: {}
        }
    }

    componentWillMount() {
        this.loadProducts();
    }

    componentDidUpdate(prevProps) {
        // Si el proveedor seleccionado cambia, actualizamos los items filtrados
        if (prevProps.selectedProvider !== this.props.selectedProvider) {
            this.filtrarItems();
        }
        // La precarga desde un pedido llega por PROP y puede llegar TARDE: el padre
        // (AddRestockingPage) pide el pedido en su componentDidMount y este componente pide el
        // catálogo en el suyo, así que cuál resuelve primero es una carrera de red.
        //
        // Aplicarla sólo dentro del `.then` de loadProducts —como estaba— la pierde cada vez que
        // gana el catálogo: `preloadedItems` todavía viene vacío y las filas del pedido no
        // aparecen NUNCA. No falla, no avisa: la pantalla queda como si el pedido no tuviera
        // ítems, y el operador carga la reposición a mano sin notar que faltan. Es lo que tenía
        // los dos tests e2e de esta pantalla en `test.fixme`.
        //
        // Con las dos puertas (acá y en el `.then`), cualquiera de los dos órdenes funciona.
        if (prevProps.preloadedItems !== this.props.preloadedItems) {
            this.aplicarPrecarga();
        }
    }

    // Traduce los ítems del pedido a la selección del componente, contra el catálogo ya bajado.
    // Devuelve {} si todavía no hay catálogo o no hay nada que precargar.
    construirPrecarga = (allItems, preloaded) => {
        const seleccion = {};
        if (!Array.isArray(allItems) || allItems.length === 0) return seleccion;
        (preloaded || []).forEach((preItem) => {
            const found = allItems.find((p) => p.code === preItem.code);
            if (!found) return;
            seleccion[`${found.prefix}${found.code}`] = {
                prefix: found.prefix,
                code: found.code,
                name: found.name,
                quantity: preItem.quantityToOrder,
                price: found.price,
                cost: found.cost || 0,
                discount: found.discount,
                productType: found.productType
            };
        });
        return seleccion;
    }

    aplicarPrecarga = () => {
        const precargados = this.construirPrecarga(this.state.items, this.props.preloadedItems);
        if (Object.keys(precargados).length === 0) return;
        // Se MERGEA sobre lo ya seleccionado en vez de reemplazar: si el operador alcanzó a
        // tildar algo a mano antes de que llegara el pedido, no se le borra.
        const itemsSelected = { ...this.state.itemsSelected, ...precargados };
        this.props.onChangeData(itemsSelected);
        this.setState({ itemsSelected }, this.filtrarItems);
    }
    
    loadProducts = () => {
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product/forceAll', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const allItems = data.data;
                // Si el pedido YA llegó, se aplica acá. Si no, lo aplica componentDidUpdate
                // cuando llegue: son las dos puertas de la carrera.
                const itemsSelected = this.construirPrecarga(allItems, this.props.preloadedItems);
                if (Object.keys(itemsSelected).length > 0) {
                    this.props.onChangeData(itemsSelected);
                }
                this.setState({ items: allItems, itemsSelected }, this.filtrarItems);
            }
        });
    }

    filtrarItems = () => {
        const input = document.getElementById("input_search") ? document.getElementById("input_search").value : '';
        const selectedProvider = this.props.selectedProvider;
        const newList = this.state.items.filter(item => {
            const name = item.name.toLowerCase();
            const code = (item.prefix + item.code).toLowerCase();
            const matchesSearch = input !== '' ? name.includes(input.toLowerCase()) || code.includes(input.toLowerCase()) : true;
            const matchesProvider = item.provider == selectedProvider;
            return matchesSearch && matchesProvider;
        });
        this.setState({ itemsFiltered: newList });
    }
    
    onChangeItem = (e) => {
        var itemsSelected = this.state.itemsSelected;
        if (e.target.checked) {
            var item = undefined;
            this.state.items.forEach(element => {
                var code = `${element.prefix}${element.code}`
                if (code === e.target.id) {
                    item = {
                        prefix: element.prefix,
                        code: element.code,
                        name: element.name,
                        quantity: 1,
                        price: element.price,
                        cost: element.cost,
                        discount: element.discount,
                        productType: element.productType
                    }
                }
            })
            itemsSelected[e.target.id] = item;
        } else {
            delete itemsSelected[e.target.id]
        }
        //Update parent and state
        this.props.onChangeData(itemsSelected);
        this.setState({itemsSelected: itemsSelected});
    }

    loadItems = () => {
        var items = [];
        for(var i=0; i<this.state.itemsFiltered.length; i++) {
            var data = this.state.itemsFiltered[i];
            items.push(
                <div className="custom-control custom-checkbox mb-1" key={`${data.prefix}${data.code}`}>
                    <input onChange={(e) => this.onChangeItem(e)} type="checkbox" className="custom-control-input" id={`${data.prefix}${data.code}`} defaultChecked={`${data.prefix}${data.code}` in this.state.itemsSelected}/>
                    <label className="custom-control-label" htmlFor={`${data.prefix}${data.code}`}>{ data.name } ({data.stock})</label>
                </div>
            );
        }
        return (
            <div className="items">{ items }</div>
        );
    }

    onChangeInput = () => {
        this.filtrarItems();
    }

    drawModal = () => {
        return(
            <div className="modal fade" id={`modal-products`} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{textAlign: "center"}}>Agregar producto</h4>
                            <div className="form-group" style={{marginBottom: '0'}}>
                                <input type="text" className="form-control" id="input_search" placeholder="Buscar" onChange={() => this.onChangeInput()}/>
                            </div>
                        </div>
                        <div className="modal-body" style={{maxHeight: '70vh', overflowY: 'auto'}}>
                            { this.loadItems() }
                        </div>                        
                        <div className="modal-footer">
                            <button 
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm" 
                                data-dismiss="modal">
                                Cerrar
                            </button>                      
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    drawTable = () => {
        return (
            <table id="add-purchase-table" style={{width: '100%'}}>
                <thead>
                    <tr role="row">
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '20%'}}>Código</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '30%'}}>Nombre</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '25%'}}>Cantidad</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '25%'}}>Costo unitario</th>
                    </tr>
                </thead>                
                { this.drawTableItems() }
            </table>
        );
    }

    drawTableItems = () => {
        var map = this.state.itemsSelected;
        var index = 0;
        var items = [];
        for (const [key, value] of Object.entries(map)) {
            items.push(this.drawRow(key, value, index));
            index++;
        }
        if (index === 0) {
            items.push(
                <tr key="no-items"><td colSpan="6" style={{textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)'}}>No tienes elementos</td></tr>
            )
        }
        return (<tbody>{ items }</tbody>)
    }

    drawRow = (code, item, index) => {
        return(
            <tr role="row" className="odd table-purchase-item" key={ code } style={{background: (index % 2 === 0) ? '#ffffff' : '#fcfcfc' }}>
                <td className="table-purchase-item">{code}</td>
                <td className="table-purchase-item">{item.name}</td>
                <td className="table-purchase-item">
                    <NumberInput id={ `${code}_quantity` } value={ item.quantity } onChange={ () => this.onChangeQuantity(code) } />
                </td>
                <td className="table-purchase-item">
                    <NumberInput id={ `${code}_cost` } value={ item.cost } onChange={ () => this.onChangeCost(code) } />
                </td>
            </tr>
        );
    }

    onChangeQuantity = (code) => {
        var newQuantity = document.getElementById(`${code}_quantity`).value
        var items = this.state.itemsSelected;
        var parsed = parseInt(newQuantity);
        items[code].quantity = newQuantity === '' ? '' : (isNaN(parsed) ? 0 : parsed);
        //Update parent and state
        this.props.onChangeData(items);
        this.setState({ itemsSelected: items });
    }

    onChangeCost = (code) => {
        var newCost = document.getElementById(`${code}_cost`).value
        var items = this.state.itemsSelected;
        var parsed = parseInt(newCost);
        items[code].cost = newCost === '' ? '' : (isNaN(parsed) ? 0 : parsed);
        //Update parent and state
        this.props.onChangeData(items);
        this.setState({ itemsSelected: items });
    }

    calculateTotalPrice = () => {
        const itemsSelected = this.state.itemsSelected;
        let totalPrice = 0;
      
        for (const key in itemsSelected) {
          if (itemsSelected.hasOwnProperty(key)) {
            const item = itemsSelected[key];
            totalPrice += item.quantity * item.cost;
          }
        }
      
        return totalPrice;
    }

    // Función de debounce
    debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Función para manejar el cambio en el input con debounce
    handleBarcodeChange = this.debounce((event) => {
        const barCode = event.target.value;
        if (barCode != null && barCode !== undefined && barCode !== 0 && barCode !== "")
        {
            var itemsSelected = this.state.itemsSelected;
            var item = undefined;
            this.state.items.forEach(element => {
                if (element.barCode === barCode) {
                    if (itemsSelected[element.prefix+element.code] != null)
                    {
                        let quantity = itemsSelected[element.prefix+element.code].quantity
                        item = {... itemsSelected[element.prefix+element.code] , quantity : quantity +1}
                    }
                    else{
                        item = {
                            prefix: element.prefix,
                            code: element.code,
                            name: element.name,
                            quantity: 1,
                            price: element.price,
                            discount: element.discount,
                            productType: element.productType
                        }
                    }                   
                    itemsSelected[element.prefix+element.code] = item;
                    this.props.onChangeData(itemsSelected);
                    this.setState({itemsSelected: itemsSelected});
                    document.getElementById("barCode").value = "";
                }
            })
            
        }        
    }, 150);

    render() {
        const totalPrice = this.calculateTotalPrice();

        return (
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div className="card-header border-bottom">
                        <div className="row">
                            <span className="col-lg-4" >Productos</span>
                            <input autoComplete="off" className="col-lg-4 form-control" type="text" id="barCode" placeholder="Código de barras" onChange={(e) => this.handleBarcodeChange(e)}/>
                            <button data-toggle="modal" data-target={`#modal-products`} type="button" className="col-lg-4 btn btn-outline-primary" style ={{float: 'right'}}>Agregar</button>
                         </div>
                    </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item p-3">
                            { this.drawTable() }
                            
                            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                <h6>Precio Total: $ {convertToMoney(totalPrice)}</h6>
                            </div>
                        </li>
                    </ul>
                </div>
                { this.drawModal() }
            </div>
        );
    }
}

export default RestockingProductComponent;